$('.slick_slider').slick({
  autoplay: true,//自動でスライドさせる
  slidesToShow: 4,
        autoplaySpeed: 0,//次の画像に切り替えるまでの時間 今回の場合は0
        speed: 3000,//画像が切り替わるまでの時間 今回の場合は難病で1枚分動くか
        cssEase: 'linear',//動きの種類は等速に
        arrows:false,//左右に出る矢印を非表示
        swipe: false,//スワイプ禁止
        pauseOnFocus: false,//フォーカスが合っても止めない
        pauseOnHover: false,//hoverしても止めない
        centerMode: false,//一枚目を中心に表示させる
        variableWidth: true,//スライドの要素の幅をcssで設定できるようにする
});